{
  "title": "Passwall",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level transmutation",
  "level": 5,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a pinch of sesame seeds)",
  "duration": "1 hour",
  "description": [
    "A passage appears at a point of your choice that you can see on a wooden, plaster, or stone surface (such as a wall, a ceiling, or a floor) within range, and lasts for the duration. You choose the opening’s dimensions: up to 5 feet wide, 8 feet tall, and 20 feet deep. The passage creates no instability in a structure surrounding it.",
    "When the opening disappears, any creatures or objects still in the passage created by the spell are safely ejected to an unoccupied space nearest to the surface on which you cast the spell."
  ],
  "spellLists": ["wizard"]
}
